<template>
  <div class="result-container">
    <!-- 顶部横幅 -->
    <TopHeader />

    <!-- 成绩统计 -->
    <div class="score-banner">
      <div class="score-item">
        <div class="score-icon icon-1">◆</div>
        <div class="score-text">
          <div class="score-value">{{ accuracy }}%</div>
          <div class="score-label">正确率</div>
        </div>
      </div>
      <div class="score-item">
        <div class="score-icon icon-2">↻</div>
        <div class="score-text">
          <div class="score-value">{{ score }}分</div>
          <div class="score-label">分数</div>
        </div>
      </div>
      <div class="score-item">
        <div class="score-icon icon-3">○</div>
        <div class="score-text">
          <div class="score-value">{{ usedTime }}</div>
          <div class="score-label">用时</div>
        </div>
      </div>
    </div>

    <!-- 题目列表 -->
    <div class="main-wrapper">
      <div class="content-card">
        <div class="question-list">
          <div
            v-for="(q, index) in questions"
            :key="index"
            :id="'question-' + index"
            class="question-item"
          >
            <div class="question-header">
              <span class="question-title">{{ index + 1 }}.{{ q.title }}</span>
              <div class="question-right">
                <span :class="['question-type', q.type === 'single' ? 'single' : 'multi']">
                  {{ q.type === 'single' ? '单选题' : '多选题' }}
                </span>
                <img 
                  :src="q.favorited ? require('@/assets/image/star-select.png') : require('@/assets/image/star.png')" 
                  class="favorite-icon" 
                  @click="toggleFavorite(index)"
                />
              </div>
            </div>
            <div class="options">
              <div
                v-for="(opt, optIndex) in q.options"
                :key="optIndex"
                :class="getOptionClass(index, optIndex)"
              >
                <span :class="['option-label', q.type === 'single' ? 'circle' : 'square']">{{ ['A', 'B', 'C', 'D'][optIndex] }}</span>
                <span class="option-text">{{ opt }}</span>
              </div>
            </div>
            <!-- 答案解析 -->
            <div class="answer-section">
              <div class="answer-info">
                <span class="answer-label">正确答案：{{ getAnswerText(q.answer) }}</span>
                <span v-if="q.selected.length > 0" class="your-answer">你的答案：{{ getAnswerText(q.selected) }}</span>
              </div>
              <div class="answer-explain">{{ q.explain }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 回到顶部 -->
      <div class="back-top" @click="scrollToTop">
        <img src="@/assets/image/up.png" class="arrow-icon" />
        <span>顶部</span>
      </div>
    </div>

    <!-- 底部答题卡 -->
    <div class="footer-bar">
      <div class="footer-content">
        <div class="answer-card-toggle">
          <img src="@/assets/image/down.png" class="arrow-icon" />
          <span>答题卡</span>
        </div>
        <div class="pagination">
          <span
            v-for="(q, index) in questions"
            :key="index"
            :class="['page-num', getPageNumClass(index)]"
            @click="scrollToQuestion(index)"
          >{{ index + 1 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'

export default {
  name: 'ResultPage',
  components: {
    TopHeader
  },
  data() {
    return {
      accuracy: 12,
      score: 24,
      usedTime: '5分钟',
      questions: [
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'single',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [0],
          selected: [0],
          favorited: true,
          explain: '青石板路被晨露浸得微凉，踩上去时，鞋底与石缝间的落叶摩擦出细碎声响，像秋日私语。巷弄不宽，两侧老墙爬着枯褐的藤萝，残留的几片黄叶在风里轻轻晃，阳光穿过斑驳的枝桠，在墙上投下班驳的光影，随秋风缓缓流动。巷口的老槐树落了大半叶子，枝桠遒劲地指向天空，树下的石凳上还留着半片被风吹落的枫叶，边缘已泛着深褐。偶尔有老人牵着猫。'
        },
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'multi',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [0, 1],
          selected: [1],
          favorited: false,
          explain: '青石板路被晨露浸得微凉，踩上去时，鞋底与石缝间的落叶摩擦出细碎声响，像秋日私语。巷弄不宽，两侧老墙爬着枯褐的藤萝，残留的几片黄叶在风里轻轻晃，阳光穿过斑驳的枝桠，在墙上投下班驳的光影，随秋风缓缓流动。'
        },
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'single',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [1],
          selected: [1],
          favorited: false,
          explain: '解析内容'
        },
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'single',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [1],
          selected: [0],
          favorited: false,
          explain: '解析内容'
        },
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'single',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [1],
          selected: [],
          favorited: false,
          explain: '解析内容'
        },
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'single',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [1],
          selected: [],
          favorited: false,
          explain: '解析内容'
        },
        {
          title: 'Python装饰器在工程实践中常用于?',
          type: 'single',
          options: ['修改函数传入参数的类型', '为现有函数添加额外功能（如日志或计时）', '创建新的类方法', '自动处理所有函数异常'],
          answer: [1],
          selected: [1],
          favorited: false,
          explain: '解析内容'
        }
      ]
    }
  },
  methods: {
    toggleFavorite(index) {
      this.questions[index].favorited = !this.questions[index].favorited
    },
    getOptionClass(qIndex, optIndex) {
      const q = this.questions[qIndex]
      const isSelected = q.selected.includes(optIndex)
      const isCorrect = q.answer.includes(optIndex)

      if (isCorrect) {
        return ['option', 'correct']
      }
      if (isSelected && !isCorrect) {
        return ['option', 'wrong']
      }
      return ['option']
    },
    getPageNumClass(index) {
      const q = this.questions[index]
      if (q.selected.length === 0) return ''
      const isCorrect = JSON.stringify([...q.selected].sort()) === JSON.stringify([...q.answer].sort())
      return isCorrect ? 'correct' : 'wrong'
    },
    getAnswerText(arr) {
      return arr.map(i => ['A', 'B', 'C', 'D'][i]).join('、')
    },
    scrollToTop() {
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    },
    scrollToQuestion(index) {
      const el = document.getElementById('question-' + index)
      if (el) {
        const headerHeight = 80
        const top = el.offsetTop - headerHeight
        document.documentElement.scrollTop = top
        document.body.scrollTop = top
      }
    }
  }
}
</script>

<style scoped>
.result-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding-bottom: 70px;
  padding-top: 70px;
}

.score-banner {

  background-size: cover;
  background-position: center;
  padding: 25px 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
}

.score-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.score-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.score-icon.icon-1 {
  color: #f5a623;
}

.score-icon.icon-2 {
  color: #7b68ee;
}

.score-icon.icon-3 {
  color: #00bfff;
}

.score-text {
  display: flex;
  flex-direction: column;
}

.score-value {
  font-size: 24px;
  color: #333;
  font-weight: 600;
}

.score-label {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}

.main-wrapper {
  max-width: 900px;
  margin: 20px auto;
  padding: 0 20px;
}

.content-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.question-list {
  padding: 0 25px;
}

.question-item {
  padding: 25px 0;
  border-bottom: 1px solid #f0f0f0;
}

.question-item:last-child {
  border-bottom: none;
}

.question-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 18px;
}

.question-title {
  flex: 1;
  font-size: 15px;
  color: #333;
  line-height: 1.6;
}

.question-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.question-type {
  font-size: 14px;
  font-weight: 500;
}

.question-type.single {
  color: #3d8c40;
}

.question-type.multi {
  color: #e74c3c;
}

.favorite-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 6px;
  background: #fff;
}

.option.correct {
  background: #d4edda;
}

.option.correct .option-label {
  background: #3d8c40;
  color: #fff;
  border-color: #3d8c40;
}

.option.wrong {
  background: #f8d7da;
}

.option.wrong .option-label {
  background: #e74c3c;
  color: #fff;
  border-color: #e74c3c;
}

.option-label {
  width: 26px;
  height: 26px;
  border: 2px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #666;
}

.option-label.circle {
  border-radius: 50%;
}

.option-label.square {
  border-radius: 4px;
}

.option-text {
  font-size: 14px;
  color: #333;
}

.answer-section {
  margin-top: 20px;
  padding: 15px;
  background: #fafafa;
  border-left: 3px solid #3d8c40;
  border-radius: 0 6px 6px 0;
}

.answer-info {
  display: flex;
  gap: 20px;
  margin-bottom: 12px;
  font-size: 13px;
}

.answer-label {
  color: #3d8c40;
}

.your-answer {
  color: #666;
}

.answer-explain {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}

.back-top {
  position: fixed;
  right: 30px;
  bottom: 100px;
  padding: 10px 15px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 12px;
  height: 12px;
}

.footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e8e8e8;
}

.footer-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 15px 25px;
  display: flex;
  align-items: center;
  gap: 25px;
}

.answer-card-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  color: #666;
}

.pagination {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.page-num {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  cursor: pointer;
  background: #f5f5f5;
  color: #666;
}

.page-num.correct {
  background: #3d8c40;
  color: #fff;
}

.page-num.wrong {
  background: #e74c3c;
  color: #fff;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .score-banner {
    padding: 20px 15px;
    gap: 30px;
  }

  .score-icon {
    width: 30px;
    height: 30px;
    font-size: 24px;
  }

  .score-value {
    font-size: 18px;
  }

  .score-label {
    font-size: 11px;
  }

  .main-wrapper {
    margin: 15px auto;
    padding: 0 10px;
  }

  .question-list {
    padding: 0 15px;
  }

  .question-item {
    padding: 20px 0;
  }

  .footer-content {
    padding: 12px 15px;
    gap: 15px;
  }

  .page-num {
    width: 26px;
    height: 26px;
    font-size: 12px;
  }
}
</style>
